import api from "api/config";

export const CreateSatisfactionFormAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/satisfaction/forms",
    data,
  });

  return response;
};

export const GetSatisfactionFormAPI = async (params) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/forms",
    params,
  });

  return response;
};

export const GetSatisfactionFormByIdAPI = async (formId) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/satisfaction/forms/${formId}`,
  });

  return response;
};

export const UpdateSatisfactionFormAPI = async ({ formId, data }) => {
  const response = await api({
    method: "PATCH",
    url: `/api/v1/satisfaction/forms/${formId}`,
    data,
  });

  return response;
};

// ================= PUBLIC SUBMISSION =================

export const SubmitSatisfactionFormAPI = async (data) => {
  const response = await api({
    method: "POST",
    url: "/api/v1/satisfaction/public/submit",
    data,
  });

  return response;
};

export const ValidateSatisfactionReservationAPI = async (reservationId) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/public/validate",
    params: {
      reservationId,
    },
  });

  return response;
};

// ======================================================

export const GetSatisfactionCountersAPI = async (params) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/stats/counters",
    params,
  });

  return response;
};

export const GetSatisfactionTextSummaryAPI = async (params) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/stats/text-summary",
    params,
  });

  return response;
};

export const GetSatisfactionRatingStatsAPI = async (params) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/stats/rating",
    params,
  });

  return response;
};

export const GetSatisfactionMultipleChoiceStatsAPI = async (params) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/stats/multiple-choice",
    params,
  });

  return response;
};

export const GetRecentSatisfactionTextAnswersAPI = async (params) => {
  const response = await api({
    method: "GET",
    url: "/api/v1/satisfaction/stats/text-recent",
    params,
  });

  return response;
};
